import React from "react";
import classnames from "classnames";
import PropTypes from "prop-types";

import styles from "./delimiter.module.scss";

const Delimiter = ({className}) => {
  return (
    <span className={classnames(styles["delimiter"], className)}>|</span>
  );
};

Delimiter.propTypes = {
  className: PropTypes.string,
};

export default Delimiter;
